import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { BUSINESS } from "@/config/business";
import { trackDevisMerci } from "@/lib/analytics";

export const Route = createFileRoute("/merci")({
  head: () => ({
    meta: [
      { title: "Merci — demande bien reçue | DJ Val" },
      { name: "robots", content: "noindex,follow" },
      {
        name: "description",
        content: "Votre demande de devis a bien été reçue. Réponse personnalisée sous 24 h.",
      },
      { property: "og:title", content: "Merci — demande bien reçue | DJ Val" },
      { property: "og:description", content: "Votre demande de devis a bien été reçue." },
      { property: "og:url", content: "https://dj-val.fr/merci" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://dj-val.fr/merci" }],
  }),
  component: Page,
});

function Page() {
  useEffect(() => {
    trackDevisMerci();
  }, []);
  return (
    <div className="bg-background text-muted-foreground min-h-[70vh] flex items-center px-6 py-24">
      <div className="max-w-2xl mx-auto text-center">
        <p className="text-[10px] uppercase tracking-[0.32em] text-[var(--gold)] font-semibold">
          Demande enregistrée
        </p>
        <h1 className="font-serif-display text-4xl sm:text-5xl text-foreground mt-4 leading-tight">
          Merci, votre demande est <span className="italic">bien reçue</span>
        </h1>
        <span className="gold-rule mx-auto !w-12 my-6 block" />
        <p className="text-base font-light leading-relaxed">
          Je vous réponds personnellement <strong className="text-foreground">sous 24 h</strong> avec
          une proposition adaptée à votre événement. Pensez à vérifier vos spams : la réponse
          arrive depuis <span className="text-foreground">{BUSINESS.email ?? "info.djval@gmail.com"}</span>.
        </p>
        <p className="mt-6 text-sm">
          Une urgence ou une date à bloquer tout de suite ?
        </p>
        <a
          href="tel:0767908667"
          data-cta-location="merci"
          className="mt-3 inline-block bg-[var(--gold)] text-[var(--ink)] px-10 py-4 text-[13px] font-semibold tracking-[0.15em]"
          style={{ fontFamily: "Arial, sans-serif", fontVariantNumeric: "tabular-nums" }}
        >
          07 67 90 86 67
        </a>
        <div className="mt-10 flex flex-wrap justify-center gap-6 text-[11px] uppercase tracking-[0.2em]">
          <Link to="/galerie" className="hover:text-[var(--gold)] transition-colors">
            Voir les réalisations
          </Link>
          <Link to="/tarifs" className="hover:text-[var(--gold)] transition-colors">
            Consulter les tarifs
          </Link>
          <Link to="/" className="hover:text-[var(--gold)] transition-colors">
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}
